import axiosInstance from "@/store/axios.instance";

export default {
    namespaced: true,
    state() {
        return {
            daggemiddelden: null,
            maandgemiddelde: null,
            afgegladgemiddelden: null,
            afgegladgemiddelde: null,
        }
    },
    mutations: {
        setDaggemiddelden(state, rapport) {
            state.daggemiddelden = rapport.daggemiddeldeDtos
        },
        setMaandgemiddelde(state, rapport) {
            state.maandgemiddelde = rapport.maandgemiddeldeDto
        },
        setAfgegladgemiddelden(state, rapport) {
            state.afgegladgemiddelden = rapport
        },
        setAfgegladgemiddelde(state, rapport) {
            state.afgegladgemiddelde = rapport.afgegladGemiddeldeDto
        }
    },
    actions: {
        async fetchRol({commit}) {
            await axiosInstance.get("/zon/raporten/daggemiddelden")
                .then(result => {
                    commit('setDaggemiddelden', result.data)
                    commit('setMaandgemiddelde', result.data)
                    commit('setAfgegladgemiddelde', result.data)
                })
        },
        async fetchAfgeglad({commit}) {
            await axiosInstance.get("/zon/raporten/maandgemiddelden/afgeglad")
                .then(result => {
                    commit('setAfgegladgemiddelden', result.data)
                })
        },
        async downloadExcel({commit}, date) {
            try {
                const yearMonth = date.slice(0, 7).replace("-", "") // "2025-04" => "202504"
                const filename = `${yearMonth}_tabellen.xlsx`
                const response = await axiosInstance.get("/zon/raporten/maandgemiddelden/tabel/excel", {
                    params: {date}, // Pass the date as a query parameter
                    responseType: 'blob'
                });
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                })
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', filename)
                document.body.appendChild(link)
                link.click()
                link.remove()
                window.URL.revokeObjectURL(url)
            } catch (error) {
                console.error("Excel download failed:", error)
            }
        },
        async downloadWaarnemers({commit}) {
            try {
                const response = await axiosInstance.get("/zon/raporten/waarnemers/lijst", {
                    responseType: 'blob'
                });
                let filename = "Waarnemers.xlsx"; // default fallback
                const disposition = response.headers['content-disposition'];
                if (disposition && disposition.indexOf('filename=') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                }
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                })
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', filename)
                document.body.appendChild(link)
                link.click()
                link.remove()
                window.URL.revokeObjectURL(url)
            } catch (error) {
                console.error("Excel download failed:", error)
            }
        },
        async downloadMaandWaarnemer({ commit }, data) {
            try {
                const date = data.date;
                const yearMonth = date.slice(0, 7).replace("-", ""); // "2025-04" => "202504"
                let filename = `${yearMonth}_waarnemingen`;
                if (data.extraNaam === null){
                    filename = filename + ".xlsx"
                } else {
                    filename = filename +"_" +  data.extraNaam + ".xlsx"
                }
                const response = await axiosInstance.get(
                    "/zon/raporten/waarnemingen/maand/waarnemer/" + data.id,
                    {
                        params: { date },
                        responseType: "blob", // needed for file download
                        validateStatus: () => true, // prevent Axios from throwing automatically
                    }
                );

                // If backend returned an error JSON instead of a file
                if (response.status >= 400) {
                    // read blob as text
                    const text = await response.data.text();
                    let message = "Onbekende fout bij downloaden";
                    try {
                        const json = JSON.parse(text);
                        message = json.message || json.error || message;
                    } catch (_) {}
                    throw new Error(message); // will propagate to your component
                }
                // Normal file download
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                throw error; // propagate to component
            }
        },

        //ToDo: Tijdelijke code voor lijst van alle waarnemingen van een maand binnen te halen. Eerst overleg met Ruben voor structuur
        async  downloadMaandAlleWaarnemers({ commit }, date){
            await axiosInstance.get("/zon/raporten/waarnemingen/maand/waarnemers", {
                params: { date },
        }).then(result => console.log(result.data))
        }
    },
}